import React from 'react';
import i18n from '@i18n';
import { FooterPaymentMethodsList } from 'nike-ui/src/components/footer/components/FooterPaymentMethodsList';
import './FooterPartnerMethods.less';

const FooterPaymentMethods = () => (
    <div className="footer-payment-methods-container">
        <div className="footer-payment-methods-title text-center">
            <span>{i18n('footer.paymentMethods')}</span>
        </div>
        <div className="text-center">
            <FooterPaymentMethodsList imgHeight="14px" className={'payment-methods-icon'} />
        </div>
    </div>
);

export default FooterPaymentMethods;
